import { render, staticRenderFns } from "./ResultPanel.vue?vue&type=template&id=66f8c8d0&scoped=true&"
import script from "./ResultPanel.vue?vue&type=script&lang=ts&"
export * from "./ResultPanel.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./ResultPanel.vue?vue&type=style&index=0&id=66f8c8d0&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "66f8c8d0",
  null
  ,true
)

export default component.exports